import { styled } from "@mui/material/styles";
import { MenuItem } from "@mui/material";

export const CMenuItem = styled(MenuItem)(() => ({
  textTransform: "capitalize",
}));
